// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../node_modules/postcss-loader/dist/cjs.js!../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section_XQvXH {
  /*background: var( --background );*/
}

.section_XQvXH > * {
  margin-left : 10px;
  margin-right : 10px;
}

.headerContent_JL57z {
  display:flex;
  flex-direction:row;
  background: #ffffff;
  color: white;
  margin-left:0;
  margin-right:0;
  align-items: center;
  justify-content: space-between;
  padding:5px 10px 5px 10px;
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
}

/* not good here */
.section_XQvXH:first-child > .headerContent_JL57z {
  border-top:none;
}
/*
.header, .title {
  font-size:14px;
  font-weight: 300;
  color:var( --purple );
}
*/


.title_FEgIi, .header_wsd7P {
  font-size:16px;
  font-weight: bold;
  color:var( --purple );
}

.subtitle_fcIKR {
  margin-bottom:0;
  font-size:14px;
  font-weight: 300;
  /*padding: 5px 10px 0 10px;*/
  color:var( --purple );
}
`, "",{"version":3,"sources":["webpack://./src/views/section.css"],"names":[],"mappings":"AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,eAAe;AACjB;AACA;;;;;;CAMC;;;AAGD;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;AACvB","sourcesContent":["@import \"../style/theme.css\";\n\n.section {\n  /*background: var( --background );*/\n}\n\n.section > * {\n  margin-left : 10px;\n  margin-right : 10px;\n}\n\n.headerContent {\n  display:flex;\n  flex-direction:row;\n  background: #ffffff;\n  color: white;\n  margin-left:0;\n  margin-right:0;\n  align-items: center;\n  justify-content: space-between;\n  padding:5px 10px 5px 10px;\n  border-top: 1px solid #e5e5e5;\n  border-bottom: 1px solid #e5e5e5;\n}\n\n/* not good here */\n.section:first-child > .headerContent {\n  border-top:none;\n}\n/*\n.header, .title {\n  font-size:14px;\n  font-weight: 300;\n  color:var( --purple );\n}\n*/\n\n\n.title, .header {\n  font-size:16px;\n  font-weight: bold;\n  color:var( --purple );\n}\n\n.subtitle {\n  margin-bottom:0;\n  font-size:14px;\n  font-weight: 300;\n  /*padding: 5px 10px 0 10px;*/\n  color:var( --purple );\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `section_XQvXH`,
	"headerContent": `headerContent_JL57z`,
	"title": `title_FEgIi`,
	"header": `header_wsd7P`,
	"subtitle": `subtitle_fcIKR`
};
export default ___CSS_LOADER_EXPORT___;
